import type { RouteConfig } from "@/types/routestypes";
import { lazy } from "react";

const LeaveSettingsPage = lazy(() => import("@/pages/LeaveSettings/LeaveSettingsPage"));
const LeaveSettings = lazy(() => import("@/pages/LeaveSettings/LeaveSettings"));
const SetLeaveApprover = lazy(() => import("@/pages/LeaveSettings/SetLeaveApprover"));
const LeavePolicy = lazy(() => import("@/pages/LeaveSettings/LeavePolicy/LeavePolicy"));
const LeaveCompliance = lazy(() => import("@/pages/LeaveSettings/LeaveCompliance/LeaveCompliance"));

const LeaveSettingRoute: RouteConfig = {
    path: "",
    pageName: "Leave Setting",
    permission: ["LeaveSetting"],
    element: <LeaveSettingsPage />,
    children: {
        LEAVE_SETTINGS: {
            path: "leavesettingcmp",
            element: <LeaveSettings />,
            pageName: "Leaves Setting",
            sidebar: { show: true },
        },
        SET_LEAVE_APPROVER: {
            path: "setapprovers",
            element: <SetLeaveApprover />,
            pageName: "Set Leave Approver",
            sidebar: { show: true },
        },
        LEAVE_POLICY: {
            path: "leavepolicy",
            element: <LeavePolicy />,
            pageName: "Leave Policy",
            sidebar: { show: true },
        },
        LEAVE_COMPLIANCE: {
            path: "leavecompliance",
            element: <LeaveSettingsPage />,
            pageName: "Compliance Management",
            sidebar: { show: true },
            children: {
                MAIN: {
                    path: "",
                    element: <LeaveCompliance defaultTab={0} />,
                    pageName: "Compliance Profile",
                    sidebar: { show: false },
                },
                COMPLIANCE_PROFILE: {
                    path: "profile",
                    element: <LeaveCompliance defaultTab={0} />,
                    pageName: "Compliance Profile",
                    sidebar: { show: true },
                },
                LEGAL_SOURCE: {
                    path: "legalsource",
                    element: <LeaveCompliance defaultTab={1} />,
                    pageName: "Legal Source",
                    sidebar: { show: true },
                },
                STATUTORY_RULE: {
                    path: "statutoryrule",
                    element: <LeaveCompliance defaultTab={2} />,
                    pageName: "Statutory Rule",
                    sidebar: { show: true },
                },
                RULE_VERSION_HISTORY: {
                    path: "history",
                    element: <LeaveCompliance defaultTab={3} />,
                    pageName: "Rule Version History",
                    sidebar: { show: true },
                },
            }
        }
    }
}
export default LeaveSettingRoute;
